<template>
	<div class="login">
		<v-overlay :value="true" z-index="1000">
			<v-progress-circular
			indeterminate
			size="100"
			></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
import {
	mapActions
} from 'vuex'

export default {
	components: {},
	methods: {
		...mapActions('authSeller', ['loginsso', 'logout']),

		async processLogin () {
			const authKey = 'hwiecom-seller-auth-data'
			const tokens = await decodeURIComponent(this.$route.query.token)
			const activeUser = await localStorage.getItem(authKey)
			
			if (activeUser) await this.logout()

			// eslint-disable-next-line no-unused-vars
			// const jsonPayload = await atob(tokens).split('').map(function(c) {
			// 		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			// }).join('');
			const jsonPayload = await atob(tokens)

			this.loginsso(JSON.parse(jsonPayload)).then(async() => {
				const authData = await localStorage.getItem(authKey);
				const data = await JSON.parse(authData)
				this.dataMitra = await data

				setTimeout(() => {
					if ((Object.keys(data).length > 0) && data !== undefined) {
						this.$router.push({
							name: "seller-dashboard"
						})
					} else {
						this.$router.push({
							name: "login-seller"
						})
					}
				}, 1200);
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Login SSO Seller');
		this.processLogin()
	}
};
</script>
